var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerttriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.0454V10.6969M10 13.3485H10.0067M8.85433 4.63819L3.17957 14.0114C3.06257 14.2118 3.00066 14.4391 3.00001 14.6706C2.99935 14.9021 3.05997 15.1297 3.17583 15.3308C3.2917 15.532 3.45877 15.6995 3.66042 15.8169C3.86207 15.9343 4.09128 15.9975 4.32524 16H15.6748C15.9087 15.9975 16.1379 15.9343 16.3396 15.8169C16.5412 15.6995 16.7083 15.532 16.8242 15.3308C16.94 15.1297 17.0007 14.9021 17 14.6706C16.9993 14.4391 16.9374 14.2118 16.8204 14.0114L11.1457 4.63819C11.0262 4.44337 10.8581 4.2823 10.6574 4.17051C10.4567 4.05873 10.2303 4 10 4C9.7697 4 9.54329 4.05873 9.34262 4.17051C9.14194 4.2823 8.97377 4.44337 8.85433 4.63819Z",
    stroke: "#F05A30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerttriangle);
export default __webpack_public_path__ + "static/media/alerttriangle.c94d593dc59cdd794b0f8daa390c6065.svg";
export { ForwardRef as ReactComponent };